/* SessionDetailsList.tsx generated by @compiled/babel-plugin v3.0.2 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4bt5LAnQyn%7Boverflow-x%3Ahidden%7D%0A._2WAcuGnQyn%7Boverflow-y%3Ahidden%7D%0A._2sNsIg7NXe%7Bfont%3Avar(--ds-font-body-small%2Cnormal%20400%209pt%2F1pc%20%22Atlassian%20Sans%22%2Cui-sans-serif%2C-apple-system%2CBlinkMacSystemFont%2C%22Segoe%20UI%22%2CUbuntu%2C%22Helvetica%20Neue%22%2Csans-serif)%7D%0A._3iDTPbQ4SZ%7Bdisplay%3Aflex%7D%0A._0hPCNLDIqT%7Balign-items%3Acenter%7D%0A._3TGfC9LRg7%7Bflex-wrap%3Anowrap%7D%0A._39xV02N91d%7Bwidth%3A100%25%7D%0A._4ouGXIdnbC%7Bmin-width%3A0%7D%0A._1EqgXlN91d%7Bmax-width%3A100%25%7D%0A._1ANEUSLRg7%7Bwhite-space%3Anowrap%7D%0A._1UtDYzKGUX%7Bcolor%3Avar(--ds-text-subtlest%2C%236b6e76)%7D%0A._0LQT5E1Y8M%7Bpadding-inline-start%3Avar(--ds-space-050%2C4px)%7D%0A._03SyCP1Y8M%7Bpadding-inline-end%3Avar(--ds-space-050%2C4px)%7D%0A._3YEZNOdnbC%7Bflex-shrink%3A0%7D");













import React, { Children, Fragment, isValidElement, type ReactNode } from 'react';
import { Box } from '@atlaskit/primitives/compiled/box';
const styles = {
  container: "_4bt5LAnQyn _2WAcuGnQyn _2sNsIg7NXe _3iDTPbQ4SZ _0hPCNLDIqT _3TGfC9LRg7 _39xV02N91d _4ouGXIdnbC _1EqgXlN91d _1ANEUSLRg7 _1UtDYzKGUX",
  separator: "_0LQT5E1Y8M _03SyCP1Y8M _3YEZNOdnbC"
};
export type SessionDetailsListProps = {
  children: ReactNode;
  separator?: string;
  /** The first item includes its separator in its own animated width. */
  firstItemOwnsSeparator?: boolean;
  testId?: string;
};

/** A single line of session details whose flexible details own their truncation behavior. */
export const SessionDetailsList = ({
  children,
  separator = '·',
  firstItemOwnsSeparator = false,
  testId
}: SessionDetailsListProps): React.JSX.Element | null => {
  const details = Children.toArray(children).filter(isValidElement);
  if (details.length === 0) {
    return null;
  }
  return <Box as="span" xcss={styles.container} testId={testId}>
			{details.map((detail, index) => <Fragment key={detail.key}>
					{index > 0 && !(index === 1 && firstItemOwnsSeparator) && separator ? <Box as="span" xcss={styles.separator}>
							{separator}
						</Box> : null}
					{detail}
				</Fragment>)}
		</Box>;
};